import { useApi } from '@/contexts/shared/api/UseApi.composables'
import { serviceError, serviceSuccess } from '@/contexts/shared/service-response/ServiceResponse.helpers'

import type { UsersAndGroups, UserSelectRoles, GetUsersQuery } from '@/contexts/shared/users/Users.interfaces'
import type { ServiceResponse } from '@/contexts/shared/service-response/ServiceResponse.interfaces'
import type { RestAPIUserListResponse } from '@/interfaces/ApiRest.generated.interfaces'
import { getUsersAndGroupsFromApi } from '@/contexts/shared/users/Users.services.helpers'

export const getUsers = async (
  perimeterId?: number,
  tagId?: number,
  role?: UserSelectRoles
): Promise<ServiceResponse<UsersAndGroups>> => {
  const url = '/v2/users'
  const query: GetUsersQuery = {
    perimeter_id: perimeterId,
    tag_id: tagId,
    role: role,
  }

  const { ok, code, data: response } = await useApi.get<RestAPIUserListResponse>(url, query)

  if (!ok) {
    return serviceError(code)
  }

  return serviceSuccess(getUsersAndGroupsFromApi(response.data))
}

export const checkPassword = async (password: string, token: string): Promise<ServiceResponse<void>> => {
  const url = 'user/check_password'
  const body = { value: password, token }

  const { ok, code, data } = await useApi.post<{ ok: boolean; message: string }>(url, { body })

  if (!ok) {
    return serviceError(code)
  }

  if (!data.ok) {
    return serviceError('invalid_password', data.message)
  }

  return serviceSuccess(undefined)
}
